export const GENERIC_ERROR_MESSAGE_FALLBACK = 'Unexpected error occurred.';
export const GENERIC_ERROR_TRANSLATION_KEY = 'genericErrorTranslationKey';
export const GENERIC_ERROR_STATUS = 400;

// Error IDs
export const CHANGE_USERNAME_TO_BE_UNIQUE_ERROR_ID = 'ChangeUsernameToBeUnique';
export const PUBLIC_CUSTOMER_PROFILE_WAS_NOT_FOUND = 'PublicCustomerProfileWasNotFound';
export const NOT_FOUND_ERROR = 'ResourceNotFound';
